// src/components/member-profile/member-profile.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query MemberProfileQuery($context: ContextInput!) {\n    memberProfile(context: $context) {\n      icon {\n        __typename\n        id\n        description\n        size\n        withBackground\n        token\n      }\n      headerText\n      subText\n      memberTheme\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { IconLoyaltyThemes, TextLoyaltyThemes } from "@egds/react-lodging";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkLink } from "uitk-react-link";
import { UitkLineSkeleton } from "uitk-react-skeleton";
var __Query = gql(_templateObject());
var LoadingSkeleton = function() {
    return /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        minWidth: 150,
        grow: 0
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkLineSkeleton, null))));
};
var MemberProfile = function(props) {
    var _context_identity;
    var skipSsr = props.skipSsr, setLoading = props.setLoading;
    var context = useBexApi().context;
    var isIdentified = ((_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "IDENTIFIED" /* IDENTIFIED */ ;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var memberProfile = data === null || data === void 0 ? void 0 : data.memberProfile;
    if (loading) {
        setLoading(true);
        return /* @__PURE__ */ React.createElement(LoadingSkeleton, null);
    }
    setLoading(false);
    return /* @__PURE__ */ React.createElement(Viewport, null, /* @__PURE__ */ React.createElement(ViewSmall, null, /* @__PURE__ */ React.createElement(IconLoyaltyThemes, {
        key: "account_circle",
        id: "account_circle",
        name: "account_circle",
        size: UitkIconSize.LARGE,
        theme: memberProfile === null || memberProfile === void 0 ? void 0 : memberProfile.memberTheme
    })), /* @__PURE__ */ React.createElement(ViewMedium, null, /* @__PURE__ */ React.createElement(UitkLayoutPosition, {
        display: "inline-block",
        type: "relative",
        "data-testid": "memberprofile-mediumview"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(IconLoyaltyThemes, {
        key: "account_circle",
        id: "account_circle",
        name: "account_circle",
        size: UitkIconSize.LARGE,
        theme: memberProfile === null || memberProfile === void 0 ? void 0 : memberProfile.memberTheme
    })), memberProfile && /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        direction: "column",
        alignItems: "start"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        maxWidth: "37x"
    }, /* @__PURE__ */ React.createElement(TextLoyaltyThemes, {
        size: 300,
        theme: memberProfile === null || memberProfile === void 0 ? void 0 : memberProfile.memberTheme,
        overflow: "truncate"
    }, memberProfile.headerText)), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, isIdentified ? /* @__PURE__ */ React.createElement(UitkLink, null, /* @__PURE__ */ React.createElement("button", {
        type: "button"
    }, memberProfile.subText)) : /* @__PURE__ */ React.createElement(TextLoyaltyThemes, {
        size: 200,
        theme: memberProfile === null || memberProfile === void 0 ? void 0 : memberProfile.memberTheme,
        overflow: "truncate"
    }, memberProfile.subText)))))));
};
MemberProfile.displayName = "MemberProfile";
export { MemberProfile };
//# sourceMappingURL=index.js.map